<template>
  <Dialog :common-dialog="dialog" :dialog-width="dialogWidth">
    <template v-slot:title>
      Visit Schedule ({{ scheduleOutput.length }}) {{ getDuration() }}
    </template>
    <template v-slot:body>
      <v-container>
        <table width="100%">
          <tr
            v-for="(row, index) in scheduleOutput"
            :key="index"
            :class="{ 'visit-row-hover': row.isEdited }"
          >
            <td
              class="font-size-14 font-weight-500"
              align="center"
              valign="middle"
            >
              {{ index + 1 }}.
            </td>
            <td>
              <DatePicker
                :allowed-dates="allowedDates"
                v-model="row.startDate"
                key="visit-show-schedule-start-date"
                id="visit-show-schedule-start-date"
                :min-date="todayDate"
                placeholder="Start Date"
                v-on:change="
                  updateDay($event, index);
                  row.isEdited = 1;
                "
              />
            </td>
            <td>
              <v-text-field
                readonly
                solo
                flat
                dense
                :disabled="!row.status"
                filled
                hide-details
                :value="row.daysOfWeek"
              ></v-text-field>
            </td>
            <td>
              <TimePicker
                :disabled="!row.status"
                v-model="row.startTime"
                key="visit-show-schedule-start-time"
                id="visit-show-schedule-start-time"
                :start-date="row.startDate"
                :end-date="
                  recurringSchedule.is_multi_day
                    ? row.endDate
                    : row.startDate
                "
                v-on:change="
                  row.isEdited = 1;
                  updateTimeValidation(row);
                "
                placeholder="Start Time"
              />
            </td>
            <td v-if="!!recurringSchedule.is_multi_day">
              <DatePicker
                :disabled="!row.status"
                v-model="row.endDate"
                :min-date="row.startDate"
                placeholder="End Date"
                @change="row.isEdited = 1"
              />
            </td>
            <td>
              <TimePicker
                :disabled="!row.status"
                v-model="row.endTime"
                placeholder="End Time"
                :min-time="row.startTime"
                :start-date="row.startDate"
                :end-date="
                  recurringSchedule.is_multi_day
                    ? row.endDate
                    : row.startDate
                "
                @change="
                  row.isEdited = 1;
                  updateTimeValidation(row);
                "
              />
            </td>
            <td align="center" valign="middle">
              <v-switch
                class="m-0 p-0"
                color="cyan"
                dense
                hide-details
                :false-value="0"
                :true-value="1"
                v-on:change="row.isEdited = 1"
                v-model="row.status"
                inset
              ></v-switch>
            </td>
          </tr>
        </table>
      </v-container>
    </template>
    <template v-slot:action>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="validateSchedule()"
      >
        Save
      </v-btn>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { toSafeInteger } from "lodash";
import DatePicker from "@/view/components/main-job/QDatePicker.vue";
import TimePicker from "@/view/components/main-job/TimePicker.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import {
  SET_RECURRING_DATE,
  SET_PREVIOUS_RECURRING_DATE,
/*   RESET_ENGINEER, */
  /* UPDATE_SCHEDULE_STATE */
  /* GET_RECURRING_DATE */
} from "@/core/services/store/job.module";
import moment from "moment-timezone";
import { forEach } from "lodash";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
/* import ManageJob from "@/core/plugins/job.plugin"; */

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "job-ctx-show-schedule",
  data() {
    return {
      todayDate: moment(new Date()).format("YYYY-MM-DD"),
    };
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    allowedDates(val) {
      const date = new Date(val);
      return date.getDay() !== 0; // Allow only non-Sundays
    },
    updateTimeValidation(row) {
      if (row.startTime && row.endTime) {
        const isSameDay =
          !row.endDate ||
          moment(row.startDate).isSame(moment(row.endDate), "day");
        if (isSameDay) {
          let starttime = moment(row.startTime, "hh:mm A");
          let endtime = moment(row.endTime, "hh:mm A");
          if (starttime.isAfter(endtime) || starttime.isSame(endtime)) {
            ErrorEventBus.$emit(
              "update:error",
              InitializeError("End Time must be after Start Time.")
            );
            return false;
          }
        }
      }
    },
    updateDay(date, index) {
      this.scheduleOutput[index].daysOfWeek = moment(date).format("dddd");
      if (!this.recurringSchedule.is_multi_day) {
        this.scheduleOutput[index].endDate = date;
      }
    },
    getDuration() {
      //
    },
    validateSchedule() {
      let checkValidation = true;
      forEach(this.scheduleOutput, (schedule, index) => {
        if (!this.recurringSchedule.is_multi_day) {
          schedule.endDate = schedule.startDate;
        }
        const isSameDay =
          !schedule.endDate ||
          moment(schedule.startDate).isSame(moment(schedule.endDate), "day");
        if (isSameDay && schedule.startTime && schedule.endTime) {
          let starttime = moment(schedule.startTime, "hh:mm A");
          let endtime = moment(schedule.endTime, "hh:mm A");
          if (starttime.isAfter(endtime) || starttime.isSame(endtime)) {
            ErrorEventBus.$emit(
              "update:error",
              InitializeError(
                ` Row (${index + 1}) End Time must be after Start Time.`
              )
            );
            checkValidation = false;
            return false;
          }
        }
      });
      if (checkValidation) {
        this.$store.commit(SET_RECURRING_DATE, this.scheduleOutput);
        this.$emit("next", true);
        this.$store.commit(SET_PREVIOUS_RECURRING_DATE, this.scheduleOutput);
      }
     /*  if (
        this.scheduleOutput &&
        this.scheduleOutput.some((item) => item.isEdited == 1)
      ) {
        this.$store.commit(RESET_ENGINEER);
      } */

      /* const formatDate = (date) => {
        if (moment(date).isValid()) {
          return moment(date).format("DD MMMM YYYY hh:mm A");
        }
      };

      const jobInstance = new ManageJob();

      const scheduleStartDate = this.scheduleOutput.length
        ? this.scheduleOutput[0].startDateTime
        : null;
      const scheduleEndDate = this.scheduleOutput.length
        ? new Date(
            this.scheduleOutput[this.scheduleOutput.length - 1].endDateTime
          )
        : null;

      const endTime = moment(
        `${this.recurringSchedule.start_date} ${this.recurringSchedule.end_time}`
      ).format("HH:mm:ss");

      let [hour, minute, second] = endTime.split(":");

      if (scheduleEndDate instanceof Date) {
        scheduleEndDate.setHours(hour);
        scheduleEndDate.setMinutes(minute);
        scheduleEndDate.setSeconds(second);
      }

      const activeScheduleCount =
        this.scheduleOutput?.filter((item) => item.status == 1).length || 0;

      const message = String(jobInstance.message)
        .replace("{TYPE}", this.recurringSchedule?.type?.text)
        .replace("{START_DATE_TIME}", formatDate(scheduleStartDate))
        .replace("{OCCURRENCE}", this.scheduleOutput.length)
        .replace("{ACTIVESCHEDULECOUNT}", activeScheduleCount)
        .replace("{END_DATE_TIME}", formatDate(scheduleEndDate));

      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "dbRecurringSchedule.message",
        value: message,
      }); */
      /* this.$store.dispatch(GET_RECURRING_DATE); */
      /*   console.log(checkValidation) */
    },
  },
  components: {
    Dialog,
    DatePicker,
    TimePicker,
  },
  computed: {
    ...mapGetters([
      "scheduleOutput",
      "previousScheduleOutput",
      "recurringSchedule",
    ]),
    dialogWidth() {
      return toSafeInteger((document.body.clientWidth / 100) * 70);
    },
  },
};
</script>
